import { useEffect, useState, useContext } from 'react';
import styles from './Products.module.css';
import lineTableItems from '../../assets/line_table_items.svg';
import ArrowBelow from '../../assets/arrow_below.svg';

import { getProductsByStore } from "../../hooks/Product";
import { ProductContext } from '../../context/ProductContext';
import { StoresContext } from '../../context/StoresContext';
import { AuthContext } from '../../context/AuthContext';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Products = () => {

    const { researchProducts } = useContext(ProductContext);
    const { setStore } = useContext(StoresContext);
    const { user } = useContext(AuthContext);

    const [products, setProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    useEffect(() => {
        if(user != null || user !== undefined) {
            setStore(user.stores[0])
            fetchProductsByStoreId(user.stores[0].id, currentPage, itemsPerPage);
        }
        
    }, [currentPage]);


    useEffect(() => {
        if(researchProducts !== undefined && researchProducts?.length > 0) {
            setProducts(researchProducts)
        }else {
            if(user !== null || user !== undefined) {
                fetchProductsByStoreId(user.stores[0].id, currentPage, itemsPerPage);
            }
        }
      
    },[researchProducts])


    const fetchProductsByStoreId = async (storeId, page, limit) => {
        try {
            const productData = await getProductsByStore(storeId, page, limit);
            if (productData) {
                setProducts(productData.data.products);
                setTotalItems(productData.data.totalItems || 0);
            } else {
                setProducts([]);
            }
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            setProducts([]);
        }
    };


    const handlePreviousPage = () => {
        setCurrentPage((prev) => Math.max(prev - 1, 1));
    };


    const handleNextPage = () => {
        setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)));
    };


    return (
        <div className={styles.container}>
            <ToastContainer />
            <div className={styles.infoLine}>
                <img src={ArrowBelow} alt="Seta para baixo" />
                <h4 className={styles.headerInfo}>Tabela de Produtos</h4>
                <img className={styles.lineTableItems} src={lineTableItems} alt="Linha" />


                <div className={styles.pagination}>
                    <button onClick={ handlePreviousPage } disabled={currentPage === 1}>
                        {"<"}
                    </button>
                    <span>
                        {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} de {totalItems}
                    </span>
                    <button onClick={handleNextPage} disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}>
                        {">"}
                    </button>
                </div>
            </div>

            
            <div className={styles.tableItems}>
            <table>
                <thead>
                    <tr>
                        <th><div className={styles.scrollableHeader}>Id</div></th>
                        <th><div className={styles.scrollableHeader}>Código de Barras</div></th>
                        <th><div className={styles.scrollableHeader}>Nome do Produto</div></th>
                        <th><div className={styles.scrollableHeader}>Fabricante</div></th>
                        <th><div className={styles.scrollableHeader}>Grupo</div></th>
                    </tr>
                </thead>
                <tbody>
                    { (products).map((product) => (
                        <tr key={product.id}>
                            <td>{product.id}</td>
                            <td>{product.barcode}</td>
                            <td>{product.name}</td>
                            <td>{product.manufacturer}</td>
                            <td>{product.group}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
    );
};

export default Products;